export default __webpack_public_path__ + "static/media/mario10.3d2d3454.jpg";